import {countMeasure} from '../default/';
import {conditions} from './';
import {ConditionException} from '../../modules/error';

function _munge() {//데이터 갱신시
  //TODO: Limit 기능 이용해서 dimension의 unique한 개수 조절
  let conditionFunc = function (dimensions, measures) {
    const field = this.__execs__.field;
    if (dimensions.length !== 2) throw new ConditionException();
    if (this.reverse()) {
      field.x = dimensions[1];
      field.y = dimensions[0];
    } else {
      field.x = dimensions[0];
      field.y = dimensions[1];
    }
      
    if (dimensions.length === 2 && measures.length === 1) {
      field.color = measures[0];
      return conditions[0];
    } else if (dimensions.length === 2 && measures.length === 0) {
      this.measure(countMeasure);
      field.color = measures[0];
      return conditions[1];
    } else throw new ConditionException();
  };
  this.condition(conditionFunc); // condiion 설정
  this.__execs__.munged = this.aggregate(this.reverse(), true, true);
  this.limitKeys();
}

export default _munge;


// WEBPACK FOOTER //
// ./layouts/xy-heatmap/_munge.js